module.exports = __webpack_public_path__ + "img/HK.28b95dce.png";